import { ItemsFiltersView } from './ItemsFiltersView'
import { FILTER_REDUCER_KEYS } from '../../common/src/reducers/filtersKeys'
import { ITEMS_SORT_TYPE } from '../../common/src/actions/filtersActions'

const sortTypeBlacklist = [ITEMS_SORT_TYPE.INDEX, ITEMS_SORT_TYPE.PROJECT]

export const ProjectListFiltersView = ({ ...rest }) => {
  return (
    <ItemsFiltersView
      filtersType={FILTER_REDUCER_KEYS.PROJECT_LIST}
      sortTypeBlacklist={sortTypeBlacklist}
      showSelectColumnsButton
      {...rest}
    />
  )
}
